module.exports = __webpack_public_path__ + "img/nav-burguer.14087f7f.svg";